export default "__VITE_ASSET__8a01f0fa__"